import { Chakra } from "@airhelp/react-ui-components";
import type { ChakraProps } from "@chakra-ui/react";
import type { ReactNode } from "react";

const { Text } = Chakra;

const Paragraph = ({ children, styles }: { children: ReactNode; styles: ChakraProps["sx"] }) => (
  <Text sx={styles}>{children}</Text>
);

export default Paragraph;
